<h3 class="card-title">People Changes</h3>
<div>
  <table id="people-changes-table" class="table">
    <thead>
      <tr>
        <th
          class="sort"
          (click)="
            sortTableBy($event, 'people-changes-table', 'recordDate'); getEmployeeAuditData()
          ">
          Date/time changed
        </th>
        <th>Person ID#</th>
        <th>Person Name</th>
        <th
          class="sort"
          (click)="sortTableBy($event, 'people-changes-table', 'activity'); getEmployeeAuditData()">
          Information changed
        </th>
        <th
          class="sort"
          (click)="sortTableBy($event, 'people-changes-table', 'attrName'); getEmployeeAuditData()">
          Field changed
        </th>
        <th>Original value</th>
        <th>New value</th>
        <th
          class="sort"
          (click)="sortTableBy($event, 'people-changes-table', 'userId'); getEmployeeAuditData()">
          Changed by
        </th>
      </tr>
      <tr class="filter-row">
        <th></th>
        <th>
          <input
            [(ngModel)]="filters.employeeNumberQuery"
            style="width: 100px"
            (ngModelChange)="filterBy($event)"
            class="form-control"
            placeholder="Filter..." />
        </th>
        <th>
          <input
            [(ngModel)]="filters.employeeNameQuery"
            (ngModelChange)="filterBy($event)"
            class="form-control"
            placeholder="Filter..." />
        </th>
        <th>
          <input
            [(ngModel)]="filters.activityQuery"
            (ngModelChange)="filterBy($event)"
            class="form-control"
            placeholder="Filter..." />
        </th>
        <th>
          <input
            [(ngModel)]="filters.attrNameQuery"
            (ngModelChange)="filterBy($event)"
            class="form-control"
            placeholder="Filter..." />
        </th>
        <th></th>
        <th></th>
        <th>
          <input
            [(ngModel)]="filters.userIdQuery"
            (ngModelChange)="filterBy($event)"
            class="form-control"
            placeholder="Filter..." />
        </th>
      </tr>
    </thead>
    <tbody *ngIf="data && data.length">
      <tr *ngFor="let d of data">
        <td>{{ d.DateChanged | date: 'MM/dd/yyyy h:mma' }}</td>
        <td>{{ d.EmployeeNumber }}</td>
        <td>{{ d.PersonName }}</td>
        <td>{{ d.ActivityType }}</td>
        <td>{{ d.FieldNameChanged }}</td>
        <td>{{ d.OldValue }}</td>
        <td>{{ d.NewValue }}</td>
        <td>{{ d.ChangedBy }}</td>
      </tr>
    </tbody>
    <tbody *ngIf="!data || !data.length">
      <tr>
        <td colspan="8" class="sub-row">
          <em>No results found</em>
        </td>
      </tr>
    </tbody>
  </table>
  <lib-pagination
    *ngIf="data && data.length"
    [pagination]="pagination"
    (pageChanged)="loadPage($event)"></lib-pagination>
</div>
